/** @format */

export const baseUrl = "https://calm-depths-29681.herokuapp.com/";
